






































import { Component, Vue } from 'vue-property-decorator'
import { AuthUtil } from '@/utils/auth'

@Component({
})
export default class Login extends Vue {
  username = '';
  password = '';
  formState: boolean | null = null
  isLoading = false
  captchaHolder = document.getElementById('captchaHolder');
  captchaContainer = document.getElementById('captchaContainer');
  wafToken = ''

  onSubmit () {
    this.showCaptcha()
    return window?.AwsWafCaptcha?.renderCaptcha(this.captchaContainer, {
      apiKey: process.env.VUE_APP_AWS_WAF_API_KEY,
      onSuccess: this.awsWafCaptchaSuccess,
      onError: this.setError,
      skipTitle: true,
      dynamicWidth: true
    })
  }

  setError (error: object) {
    console.log('capture error', error)
  }

  async accessToken () {
    if (this.captchaHolder) {
      this.captchaHolder.style.display = 'none'
    }
    this.isLoading = true

    try {
      await AuthUtil.authenticate(this.username, this.password, this.wafToken)
      this.$store.commit('setAuthenticated', AuthUtil.isAuthenticated)
      this.formState = null
      await this.$router.push('/')
    } catch (e) {
      this.formState = false
    }

    this.isLoading = false
  }

  awsWafCaptchaSuccess (captchaWafToken: string) {
    this.wafToken = captchaWafToken
    this.accessToken()
  }

  showCaptcha () {
    if (this.captchaHolder) {
      this.captchaHolder.style.display = 'block'
    }
  }
}
